module.exports = __webpack_public_path__ + "static/img/ios.bfb2ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/en/ios.png
// module id = 2H6B
// module chunks = 1